<div class="competitions-tab-wrapper">
  <div class="sub-tabs">
    <a routerLink="leagues" routerLinkActive="active" class="sub-tab">
      {{ "Leagues" | translate }}
    </a>
    <a routerLink="countries" routerLinkActive="active" class="sub-tab">
      {{ "Countries" | translate }}
    </a>
  </div>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
